import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import { withGlobalData } from 'app/utils/withGlobalData';
import Image from 'app/components/layouts/Image';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import listGame from "app/data/list_game.json";
import { NextSeo } from 'next-seo';
import Link from 'next/link';

import 'app/components/games/styles.css';

export default function Index() {
  const { t } = useTranslation();

  return (
    <section className="box-card-area">
      <NextSeo title={`${t('games.list_game')}`} description={`${t('games.description_game')}`} />
      <div className="d-flex">
        <div className="box-news-area">
          <div className='content_inner'>
            <Title title="games.list_game" />
            <div className="clearFix mt-3 d-flex justify-content-center flex-wrap" style={{ width: '100%' }}>
              {
                listGame.map((game, index) => {
                  return (
                    <Link className="front-page-pane" key={index} href={`/games/${game.path}`}>
                      <Image
                        disableAuto
                        showBlur
                        src={`/images/list_games/${game.image}`}
                        alt={game.path}
                      />
                    </Link>
                  )
                })
              }
            </div>
          </div>
        </div>
        <RightContent />
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async (context) => {
  return {
    props: {
      ...await serverSideTranslations(context.locale as string, ['common']),
    },
  };
});
